import React from 'react';
import ContactDetailsButtonProperties from "./ContactDetailsButtonProperties";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./ContactDetailsButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ContactDetailsStore from './ContactDetailsButtonStore';
import Modal from '../../../ui_components/Modal/Modal';
import ShowContactDetails from '../../Info/ShowContactDetails/ShowContactDetails';
import AccountBoxIcon from '@mui/icons-material/AccountBox';

const ContactDetailsButton: React.FC<ContactDetailsButtonProperties> = ({
                                                                          showIcon = true,
                                                                          showText = true,
                                                                          onlyIcon = false,
                                                                          className = '',
                                                                          clientId,
                                                                          contactId,
                                                                          rounded = false,
                                                                          size = ButtonSize.DEFAULT,
                                                                          type = ButtonType.DEFAULT
                                                                      }) => {
    const classes = useStyles(showText);

    const commonContext = useCommonContext();
    const store = new ContactDetailsStore(commonContext, clientId, contactId);

    const handleOnclick = async () => {
        await store.openModal();
        await store.loadContact();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const text = 'Detalles de contacto';
    const Icon = AccountBoxIcon;
    const Btn = () => {
        if (onlyIcon) {
            return <AccountBoxIcon
                fontSize="small"
                onClick={handleOnclick}
                className={classes.icon}
            />
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}
                           className={classes.modal_container}>
                    {store.contact && !store.loading && <ShowContactDetails contact={store.contact}/>}
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default ContactDetailsButton;
